module.exports = __webpack_public_path__ + "static/media/AdminProfilePic.dbbceede.svg";